import domContentLoaded from 'utils/domContentLoaded';

const hide = (el) => el.setAttribute('hidden', '');
const show = (el) => el.removeAttribute('hidden');

const initQuiz = (root) => {
  const steps = new Map();
  root.querySelectorAll('[data-quiz-step]').forEach((step) => {
    steps.set(step.dataset.quizStep, step);
  });

  const results = new Map();
  root.querySelectorAll('[data-quiz-result]').forEach((result) => {
    results.set(result.dataset.quizResult, result);
  });

  if (! steps.size) {
    return;
  }

  const firstStep = root.querySelector('[data-quiz-step]');
  const firstResult = root.querySelector('[data-quiz-result]');

  const hideAll = () => {
    steps.forEach(hide);
    results.forEach(hide);
  };

  const reveal = (node) => {
    hideAll();
    show(node);
    node.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  const goTo = (target) => {
    if (target && steps.has(target)) {
      reveal(steps.get(target));
      return;
    }

    if (target && results.has(target)) {
      reveal(results.get(target));
      return;
    }

    if (firstResult) {
      reveal(firstResult);
    }
  };

  root.querySelectorAll('[data-quiz-answer]').forEach((answer) => {
    answer.addEventListener('click', () => {
      const step = answer.closest('[data-quiz-step]');

      if (step) {
        step
          .querySelectorAll('[data-quiz-answer]')
          .forEach((btn) => btn.removeAttribute('aria-pressed'));
      }
      answer.setAttribute('aria-pressed', 'true');

      goTo(answer.dataset.quizNext);
    });
  });

  hideAll();
  if (firstStep) {
    show(firstStep);
  }
};

domContentLoaded(() => {
  document.querySelectorAll('.js-desire-hub-quiz').forEach(initQuiz);
});
